// Texty modalu „Záruční a pozáruční servis" na detailu produktu (serviceModal.js).
export default {
  title: 'Záruční a pozáruční servis',
  sub: 'Servisní středisko Jipos · prodejna Bílina',
  close: 'Zavřít',
  done: 'Rozumím',
  page: 'Vše o servisu',
  loading: 'Načítáme informace o servisu…',
  error: 'Informace o servisu se teď nepodařilo načíst.',
  services: 'Co nabízíme',
  pricing: 'Orientační ceník',
  why: 'Proč servis u nás',
  /** chip ceny z administrace, který znamená zdarma (zelený) */
  freeRe: /zdarma/i,
};
